module.exports = __webpack_public_path__ + "static/tfinans1-730324911adfc5558956633b86f40b70.jpg";